import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DeleteConfirmationComponent } from '../../dialogs/delete-confirmation/delete-confirmation.component';
import { MatDialog } from '@angular/material/dialog';
import { GroupSettingsComponent } from '../../dialogs/group-settings/group-settings.component';
import { MasipService } from '../../services/masip.service';

@Component({
  selector: 'app-group-details',
  templateUrl: './group-details.component.html',
  styleUrl: './group-details.component.scss',
  standalone: false
})
export class GroupDetailsComponent {
  @Input() deatails: boolean = false;
  @Input() group: any;
  @Output() changeDetails = new EventEmitter<boolean>();

  isEdit: boolean = false;
  isCreate: boolean = false;
  isBasicInfo: boolean = true;
  asociatedLines: boolean = true;


  baseConfigurations: any[] = [];
  lines: any[] = [];

  loadingApi: any;

  selectedProfile: any = null;
  groupName = '';
  constructor(
    public dialog: MatDialog,
    private masipService: MasipService,
  ) { }

  ngOnInit() {
    this.loadingApi = false;
    this.selectedProfile = this.group.profile;
    this.groupName = this.group.name;


    if (this.group.length === 0) {
      this.isCreate = true;
      this.getBaseConfigurations();
    }

  }


  closeDetails() {
    this.deatails = !this.deatails;
    this.changeDetails.emit(this.deatails);

  }

  getLinesSelected(event: any[]) {
    this.lines = event;

  }

  deleteGroup() {
    const dialogRef = this.dialog.open(DeleteConfirmationComponent, {
      width: 'fit-content',
      height: 'fit-content',
      maxWidth: '500px',
      data: { profile: this.group }
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result === 'eliminado') {
        this.closeDetails();
      }
    });
  }

  openSettings() {
    const dialogRef = this.dialog.open(GroupSettingsComponent, {
      width: '822px',
      height: '780px',

      data: { profile: this.group }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.selectedProfile = result;
    });
  }

  editLine() {
    this.isEdit = true;
  }

  cancelEdit() {
    this.isEdit = false;
    this.selectedProfile = this.group.profile;
    this.groupName = this.group.name;
  }

  getBaseConfigurations() {
    this.masipService.getBaseConfigurations().subscribe((resp: any) => {
      this.baseConfigurations = resp;
    });
  }

  saveLine() {

    var fiscalId = '';
    if (localStorage.getItem('accessAsUser') !== null) {
      fiscalId = String(localStorage.getItem('accessAsUser') || '');
    }
    let payload = {}
    if (this.selectedProfile !== undefined && this.selectedProfile !== null) {
      console.log(this.selectedProfile);
      

      payload = {
        name: this.groupName,
        fiscal_id: fiscalId,
        id_configuration_profile: this.selectedProfile.id,
        custom_configuration: true,
      };

    } else {
      payload = {
        name: this.groupName,
        fiscal_id: fiscalId,
        custom_configuration: false,
        configuration: this.baseConfigurations,
      };

    }

    if (this.isCreate) {
      this.masipService.createGroup(payload).subscribe((resp: any) => {
        this.closeDetails();

      });
    } else if (this.isEdit) {
      this.masipService.updateGroup(this.group.id, payload).subscribe((resp: any) => {
        this.closeDetails();

      });
    }
    this.isEdit = false;

  }

  basicInfo() {
    this.isBasicInfo = true;
    this.asociatedLines = false;
  }

  associatedLines() {
    this.isBasicInfo = false;
    this.asociatedLines = true;
  }

  unassociatedLine() {
    this.isBasicInfo = false;
    this.asociatedLines = false;
  }

  updateGroupLines() {
    this.masipService.setApiLoadingGlobal(true);
    let payload = {
      phone_numbers: this.lines
    }
    this.masipService.updateGroupLines(this.group.id, payload).subscribe((resp: any) => {
      this.masipService.setApiLoadingGlobal(false);
      this.closeDetails();
    });
  }
}
